<template>
  <div>
    <template v-if="!hasVoucherCode">
      <v-layout>
        <v-flex class="my-input">
          <v-text-field
            outline
            :color="theme.color"
            v-model="promocode"
            :label="$t('Input voucher code')"
            :disabled="loading"
            :hide-details="!hasError"
            @keypress="onBlur"
            maxlength="20"
            :error="hasError"
            :error-messages="hasError ? $t('Voucher code is not valid') : ''"
          ></v-text-field>
        </v-flex>
        <v-flex shrink>
          <v-btn
            style="color:#ffffff"
            :color="theme.color"
            @click="onCheckVoucher()"
            :disabled="!promocode || promocode == ''"
            :loading="loading"
          >
            {{ $t("Apply") }}
          </v-btn>
        </v-flex>
      </v-layout>
      <div class="mb-2 flex-overflow" style="place-content: center;">
        <div class="text-xs-center">
          <v-dialog v-model="dialog" width="500">
            <template v-slot:activator="{ on }">
              <v-btn
                small
                outline
                v-on="on"
                :disabled="allPromoCode.length === 0"
                :color="theme.color"
              >
                {{ $t("Select voucher code") }}
                {{ allPromoCode.length !== 0 ? "(" + allPromoCode.length + ")" : "" }}
              </v-btn>
            </template>

            <v-card outline>
              <div style="float: right;">
                <v-btn fab flat small @click="dialog = false"> <v-icon>mdi-close</v-icon></v-btn>
              </div>
              <v-card-title class="headline lighten-2" primary-title>
                <div>{{ $t("Select voucher code") }}</div>
              </v-card-title>
              <template v-for="(code, i) in allPromoCode">
                <v-card
                  class="ma-3"
                  :style="
                    code.promotype === 'piece'
                      ? 'border-left: solid 3px orange'
                      : 'border-left: solid 3px cyan'
                  "
                  :key="i"
                >
                  <v-card-text class="pa-2">
                    <v-layout>
                      <v-flex>
                        <v-card-text>
                          <span class="caption">{{ $t("Minimum purchase of") }} </span>
                          <span
                            class="caption"
                            :class="{
                              'cyan--text lighten-2': code.promotype == 'price',
                              'orange--text lighten-2': code.promotype == 'piece',
                            }"
                          >
                            <template v-if="code.promotype == 'price'">
                              {{ code.promovalue | numberFormat }} {{ $t("Baht") }}
                            </template>
                            <template v-else
                              >{{ code.promovalue | numberFormat }} {{ $t("Items") }}
                            </template>
                          </span>
                          <div class="caption">
                            <template v-if="code.discounttype == 'price'">
                              {{ $t("Discount price") }} {{ code.discountvalue | numberFormat }}
                              {{ $t("Baht") }}
                            </template>
                            <template v-else-if="code.discounttype == 'percent'">
                              {{ $t("Discount percent") }} {{ code.discountvalue }} %
                            </template>
                            <template v-else-if="code.discounttype == 'ship'">
                              {{ $t("Discount shipping fee") }}
                              {{ code.discountvalue | numberFormat }}
                              {{ $t("Baht") }}
                            </template>
                            <template v-else-if="code.discounttype == 'freeship'">
                              {{ $t("Free Delivery") }}
                            </template>
                          </div>
                          <div class=" mb-2">
                            <span class="primary--text" style="text-transform: uppercase;">{{
                              code.code
                            }}</span>
                          </div>
                        </v-card-text>
                      </v-flex>
                      <v-btn
                        :color="theme.color"
                        small
                        dark
                        class="ma-0"
                        @click="selectPromoCode(code.code)"
                      >
                        {{ $t("Use") }}
                      </v-btn>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </template>
              <v-divider></v-divider>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </template>
    <template v-else-if="hasVoucherCode && promotion">
      <v-card class="mb-3" style="border-left: 4px solid;" :style="{ 'border-color': theme.color }">
        <v-card-text>
          <v-layout>
            <v-flex>
              <div style="text-transform: uppercase;">
                {{ promocode }}
              </div>
              <div class="title" :style="{ color: theme.color }">
                <template v-if="promotion.freeship">
                  {{ $t("Free Delivery") }}
                </template>
                <template v-else-if="promotion.discountship > 0">
                  {{ $t("Discount Shipping Fee") }} {{ currencySign }}{{ promotion.discountship }}
                </template>
                <template v-else-if="promotion.discount > 0">
                  {{ $t("Discount") }} {{ currencySign }}{{ promotion.discount }}
                </template>
              </div>
            </v-flex>
            <v-flex shrink>
              <v-btn fab flat small @click="clearpromocodeincart" :loading="loading">
                <v-icon>mdi-close</v-icon></v-btn
              >
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>

<script>
import VoucherCodeMixin from "./VoucherCodeMixin.js";
import { mapGetters } from "vuex";
export default {
  mixins: [VoucherCodeMixin],
  computed: {
    ...mapGetters({
      theme: "getTheme",
    }),
  },
  methods: {
    onBlur(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        (charCode < 65 || charCode > 90) &&
        (charCode < 97 || charCode > 122)
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="scss">
.my-input input {
  text-transform: uppercase;
}
.flex-overflow {
  display: flex;
  overflow-y: overlay;
}
</style>
